//====== COLOR VARIABLES ======//
export const blue = '#0076ff';
export const black = '#24292e';
export const slate_grey = '#97A2B9';
export const faded_blue = "#E6EBF9";
export const light_grey = "#F9F9F9";
export const white = '#FFFFFF';